import s from './add-review-modal.module.scss'
import { Modal } from '@shared/ui/modal/modal';
import { IconStar, IconStarFilled } from "@tabler/icons-react";
import { Button } from '@shared/ui/button/button';
import { useEffect, useState } from 'react';
import { useAddReview } from '../../api/useAddReview';
import { useAddReviewModal } from '../../model/useAddReviewModal';
import { FormProvider, useForm } from 'react-hook-form';
import { ConsentBlock, ConsentCaption } from '@shared/ui/consent-block/consent-block';

export const AddReviewModal = () => {
	const {isOpen, close, modalParams} = useAddReviewModal()

	const [text, setText] = useState(modalParams?.review?.feedback_message || '')
	const [rate, setRate] = useState(modalParams?.review?.feedback_rating || 0)

	const  stars = [1, 2, 3, 4, 5];

	const {mutate: addReview} = useAddReview()
  const methods = useForm()
  const personalDataConsent = methods.watch('personal_data_consent')

	const onAddReview = () => {
		addReview({
			body: {
				rating: rate,
				message: text.trim()
			}, 
			id: modalParams?.appointmentId})
		close()
	}

	useEffect(() => {
		if(!isOpen){
			setText('')
			setRate(0)
      methods.reset()
		}
	}, [isOpen, methods])

  const handleAddReview = methods.handleSubmit(() => {
    onAddReview()
  })

  return (
		<Modal {...{isOpen, close}}>
      <FormProvider {...methods}>
			  <div className={s.card}>
					  <div className={s.reviewTitle}>Общая оценка</div>
					  <div className={s.rate}>
						  {
							  stars.map((item) => (
								  <button type="button" className={s.starButton} onClick={() => setRate(item)} key={item}>
									  {item <= rate ?  <IconStarFilled className={s.starActive}/> : <IconStar className={s.star}/>}
								  </button>
							  ))
						  }
					  </div>
					  <div className={s.areaTitle}>Ваш отзыв</div>
					  <textarea
						  className={s.textarea}
						  placeholder="Текст..."
						  value={text}
						  onChange={(e) => setText(e?.currentTarget?.value)}
					  />
            <ConsentBlock className={s.consentBlock} showPublicationConsent showUserAgreementCaption={false}/>
					  <Button
						  disabled={!(rate && text.trim() && personalDataConsent)}
						  className={s.btn}
						  onClick={handleAddReview}
						  label={'Отправить'}
					  />
            <ConsentCaption className={s.consentCaption}/>
			  </div>
      </FormProvider>
		</Modal>
  );
};
